import { AIScribeConsultationNote, AIScribeProgressNote } from "../Api/AIScribeConsultation.dto";

class AIScribeConsultationNoteModel {
    private readonly unknownNote?: string;
    private readonly progressNote?: AIScribeProgressNoteModel;
    private readonly patientConsent?: string;
    private readonly reason?: string;

    private constructor(fields: { reason?: string, patientConsent?: string, unknownNote?: string; progressNote?: AIScribeProgressNoteModel }) {
        Object.assign(this, fields);
    }

    public getUnknownNote(): string | null {
        return this.unknownNote;
    }

    public getProgressNote(): AIScribeProgressNoteModel | null {
        return this.progressNote;
    }

    public getPatientConsent(): string | null {
        return this.patientConsent;
    }

    public getReason(): string | null {
        return this.reason;
    }

    public static fromDto(dto: AIScribeConsultationNote): AIScribeConsultationNoteModel {
        if (!dto)
            return null;

        return new AIScribeConsultationNoteModel({
            reason: dto.Reason,
            unknownNote: dto.UnknownNote,
            progressNote: AIScribeProgressNoteModel.fromDto(dto.ProgressNote),
            patientConsent: dto.PatientConsent
        });
    }
}

class AIScribeProgressNoteModel {
    private readonly historyOfIllness?: string;
    private readonly exam?: string;
    private readonly followupAndPlan?: string;
    private readonly other?: string;
    private readonly patientConsent?: string;

    private constructor(fields: {
        reason?: string;
        historyOfIllness?: string;
        exam?: string;
        followupAndPlan?: string;
        other?: string;
        patientConsent?: string
    }) {
        Object.assign(this, fields);
    }

    public getHistoryOfIllness(): string | null {
        return this.historyOfIllness;
    }

    public getExam(): string | null {
        return this.exam;
    }

    public getFollowupAndPlan(): string | null {
        return this.followupAndPlan;
    }

    public getOther(): string | null {
        return this.other;
    }

    public getPatientConsent(): string | null {
        return this.patientConsent;
    }

    public static fromDto(dto: AIScribeProgressNote): AIScribeProgressNoteModel {
        if (!dto)
            return null;

        return new AIScribeProgressNoteModel({
            historyOfIllness: dto.HistoryOfIllness,
            exam: dto.Exam,
            followupAndPlan: dto.FollowupAndPlan,
            other: dto.Other
        });
    }
}

export { AIScribeConsultationNoteModel, AIScribeProgressNoteModel };
